<script setup>
  import { onMounted } from "vue";

  const dispatchDashboardReadyEvent = () => {
      window.$EventBus.dispatchEvent('advisories-dashboard-ready', {});
      window.$EventBus.dispatchEvent('dsat-dashboard-ready', {});
      window.$EventBus.dispatchEvent('lightning-dashboard-ready', {});
  }

  onMounted(() => {
    dispatchDashboardReadyEvent();
  });
</script>

<template>
  <div class="jwx-map__dashboard" data-map="dashboard" style="overflow: hidden; max-height: 100%;">
    <div class="jwx-layer-dashboards-container jwx-wrapper-block jwx-wrapper-block--fitted jwx-wrapper-block--transparent-border" style="align-self: end">
      <div id="lightning-map-info-dashboard" class="jwx-layer-dashboard" data-source="lightning"></div>
      <div id="dsat-map-info-dashboard" class="jwx-layer-dashboard" data-source="dsat"></div>
      <div id="watches-warnings-map-info-dashboard" class="jwx-layer-dashboard" data-source="advisories"></div>
    </div>
  </div>
</template>